/*
 * Want to add more shared files? go/generator-shared
 */
import Constants from './constants/';
import Services from './services/';

export default angular.module('webPublicClient.app.shared', [
  Constants.name,
  Services.name
]);



// WEBPACK FOOTER //
// ./src/app/shared/index.js